import type { NextPage } from 'next'

import { Layout } from '~/components/Layout/Private'
import { Layout as PageLayout } from '~/views/account'

const Page: NextPage = () => {
  return (
    <Layout>
      <PageLayout />
    </Layout>
  )
}

export default Page
